import type { AccordionProps } from "./Accordion";
import Accordion from "./Accordion";

export interface AccordionGroupProps {
    accordions: Array<AccordionProps>;
    expandedAccordionIndex?: number;
}

const AccordionGroup = (props: AccordionGroupProps) => {
    return (
        <>
            {props.accordions.map((accordion, i) => (
                <Accordion {...accordion} key={i} />
            ))}
        </>
    );
};

export default AccordionGroup;
